import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, Bell, Menu, X, User, LogOut, LayoutDashboard, ShoppingBag, Wrench, Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { api } from "@/lib/api";

export const Header = () => {
  const { user, logout } = useAuth();
  const s = useSettings();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (user && user.role) {
      api.get("/notifications").then(({ data }) => setUnread(data.unread)).catch(() => {});
    }
  }, [user]);

  const dashLink =
    user?.role === "admin" ? "/admin" : user?.role === "seller" ? "/seller" : "/orders";
  const dashLabel =
    user?.role === "admin" ? "لوحة الإدارة" : user?.role === "seller" ? "لوحة التشليح" : "طلباتي";
  const DashIcon = user?.role === "admin" ? Shield : user?.role === "seller" ? LayoutDashboard : ShoppingBag;

  return (
    <header className="sticky top-0 z-50 glass border-b" style={{ borderColor: "var(--border-c)" }}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" data-testid="header-logo" className="flex items-center gap-2 shrink-0">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--amber)] text-[#0B0F17]">
              <Wrench size={22} strokeWidth={2.5} />
            </span>
            <div className="leading-none">
              <span className="font-head text-2xl font-black text-white">{s.platform_name}</span>
              <span className="block text-[10px] text-[var(--text-muted)]">قطع غيار مستعملة</span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-6 text-sm">
            <Link to="/search" data-testid="nav-search-link" className="text-[var(--text-muted)] hover:text-white transition-colors">تصفح القطع</Link>
            <Link to="/request-part" data-testid="nav-request-link" className="text-[var(--text-muted)] hover:text-white transition-colors">اطلب قطعة</Link>
            <Link to="/yards" data-testid="nav-yards-link" className="text-[var(--text-muted)] hover:text-white transition-colors">التشاليح</Link>
            <Link to="/how-it-works" className="text-[var(--text-muted)] hover:text-white transition-colors">كيف تعمل؟</Link>
            <Link to="/join-seller" data-testid="nav-join-link" className="text-[var(--text-muted)] hover:text-white transition-colors">انضم كتشليح</Link>
          </nav>

          <div className="flex items-center gap-2">
            <Link to="/search" className="md:hidden p-2 text-[var(--text-muted)]" data-testid="mobile-search-icon"><Search size={22} /></Link>
            {user && user.role ? (
              <>
                <Link to="/notifications" data-testid="nav-notifications" className="relative p-2 text-[var(--text-muted)] hover:text-white">
                  <Bell size={22} />
                  {unread > 0 && <span className="absolute top-0 left-0 flex h-4 min-w-4 items-center justify-center rounded-full bg-[var(--amber)] px-1 text-[10px] font-bold text-[#0B0F17]">{unread}</span>}
                </Link>
                <Link to={dashLink} data-testid="nav-dashboard" className="hidden sm:inline-flex btn-amber !px-4 !py-2 text-sm">
                  <DashIcon size={16} /> {dashLabel}
                </Link>
                <button onClick={() => { logout(); nav("/"); }} data-testid="logout-button" className="p-2 text-[var(--text-muted)] hover:text-[var(--amber)]" title="خروج"><LogOut size={20} /></button>
              </>
            ) : (
              <Link to="/login" data-testid="header-login-button" className="btn-amber !px-4 !py-2 text-sm"><User size={16} /> دخول</Link>
            )}
            <button className="md:hidden p-2 text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t px-4 py-4 space-y-2 bg-[var(--bg-secondary)]" style={{ borderColor: "var(--border-c)" }}>
          {[["/search", "تصفح القطع"], ["/request-part", "اطلب قطعة"], ["/yards", "التشاليح"], ["/how-it-works", "كيف تعمل؟"], ["/join-seller", "انضم كتشليح"]].map(([to, label]) => (
            <Link key={to} to={to} onClick={() => setOpen(false)} className="block py-2 text-[var(--text-main)]">{label}</Link>
          ))}
          {user && user.role && (
            <Link to={dashLink} onClick={() => setOpen(false)} className="block py-2 text-[var(--amber)] font-bold">{dashLabel}</Link>
          )}
        </div>
      )}
    </header>
  );
};
